module.exports = __webpack_public_path__ + "static/media/photo-1.dd4cbfac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/crescent-extension/photo-1.jpg
// module id = 156
// module chunks = 0